import { Box, Flex } from "@chakra-ui/react";
import { AnimatePresence } from "framer-motion";
import { Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Loader } from "../ui/loaders";
import SideBar from "./sidebar";
import TopBar from "./topNav";

export default function DashboardLayout() {
  const [scrollDirection, setScrollDirection] = useState<"down" | "up" | "top">(
    "top",
  );

  useEffect(() => {
    let lastVal = 0;
    window.onscroll = function () {
      const y = window.scrollY;
      if (y > lastVal) {
        setScrollDirection("down");
      }
      if (y < lastVal) {
        setScrollDirection("up");
      }
      if (y === 0) {
        setScrollDirection("top");
      }
      lastVal = y;
    };
  }, []);

  return (
    <Box bg={"background"} style={{ width: "100%" }}>
      <Flex id={"__container"}>
        <Box
          w="230px"
          display={{ base: "none", xl: "block" }}
          position={"fixed"}
          left={0}
          top={0}
          zIndex={100}
        >
          <SideBar />
        </Box>
        <Box
          ml={{ base: 0, xl: "230px" }}
          minH={"90vh"}
          flex={1}
          position={"relative"}
        >
          <TopBar scrollDirection={scrollDirection} />

          <AnimatePresence>
            <Suspense fallback={<Loader />}>
              <Box
                px={{ base: "24px", lg: "42px" }}
                py={"102px"}
                style={{ width: "100%" }}
                maxW={"100vw"}
                overflowX={"hidden"}
              >
                <Outlet />
              </Box>
            </Suspense>
          </AnimatePresence>
        </Box>
      </Flex>
    </Box>
  );
}
